import React, { useEffect, useMemo } from "react";
// import Dashboard from "../assets/images/svgs/dashboard.svg";

import Profile from "../assets/images/svgs/user.png";
import Loyalty from "../assets/images/svgs/loyalty.svg";
import Note from "../assets/images/svgs/note.svg";
import Payment from "../assets/images/svgs/payment.svg";
import Wallet from "../assets/images/svgs/wallet.svg";
import Refer from "../assets/images/svgs/refer 1.svg";
import Leader from "../assets/images/svgs/ranking.svg";
import Betting from "../assets/images/svgs/status-up.svg";
import Mission from "../assets/images/svgs/mission.png";
import Logout from "../assets/images/svgs/back 1.svg";
import Setting from "../assets/images/svgs/setting.png";
import Live from "../assets/images/casino-icons/Live.svg";
import Others from "../assets/images/casino-icons/Others.svg";
import Virtual from "../assets/images/casino-icons/Virtual.svg";
import Crash from "../assets/images/casino-icons/Crash-Games.svg";
import VirtualCasino from "../assets/images/casino-icons/VirtualCasino.svg";
import Slot from "../assets/images/casino-icons/SlotGames.svg";
import Lobby from "../assets/images/casino-icons/Lobby.svg";
import Table from "../assets/images/casino-icons/TableGames.svg";
import Bet from "../assets/images/casino-icons/bet.svg";
import Casual from "../assets/images/casino-icons/CasualGames.svg";
import Sports from "../assets/images/casino-icons/Sports.svg";
import Fish from "../assets/images/casino-icons/FishShooting.svg";
import Video from "../assets/images/casino-icons/video.svg";
import LivePopular from "../assets/images/casino-icons/LivePopular.svg";
import Mini from "../assets/images/casino-icons/MiniGames.svg";
import Arcade from "../assets/images/casino-icons/ArcadeGames.svg";
import Bing from "../assets/images/casino-icons/BingGame.svg";

import IMG1 from "../assets/images/image 169.png";
import IMG2 from "../assets/images/image 170.png";

import IMG3 from "../assets/images/image 183.png";
import IMG4 from "../assets/images/image 184.png";
import IMPK from "../assets/images/Frame-1597880812.png";
import racing from "../assets/images/svgs/racing.svg";
import upcoming from "../assets/images/svgs/upcoming.svg";
import virrual from "../assets/images/svgs/virtual.svg";
import live from "../assets/images/svgs/live.svg";
import cricket from "../assets/images/svgs/cricket 1.svg";
import espo from "../assets/images/svgs/esports.svg";

import BgImage from "../assets/images/BG(1).jpeg";
import LoginCard from "../assets/images/Maskgroup.jpg";
import Login from "../assets/images/Group jackpot.png";
import SignUp from "../assets/images/login mask.png";
import LoginMask from "../assets/images/Groupdial.png";
import LiveChat from "../assets/images/bet-frenzy/icons/live-chat43a0.svg";
import Affiliate from "../assets/images/bet-frenzy/icons/affiliate43a0.svg";

import CricketGame from "../assets/images/bet-frenzy/homepage/Games/cricketGame.png";
import Basketball from "../assets/images/bet-frenzy/homepage/Games/Basketball.png";
import Football from "../assets/images/bet-frenzy/homepage/Games/Football.png";
import Tennis from "../assets/images/bet-frenzy/homepage/Games/Tennis.png";
import Baseball from "../assets/images/bet-frenzy/homepage/Games/Baseball 1.png";
import Formula from "../assets/images/bet-frenzy/homepage/Games/Formula 1 1.png";
import Valorant from "../assets/images/bet-frenzy/homepage/Games/Valorant 1.png";

import myBets from "../assets/images/bet-frenzy/menu-icons/rotate-left.svg";
import playLive from "../assets/images/bet-frenzy/menu-icons/play-cricle.svg";
import drafts from "../assets/images/bet-frenzy/menu-icons/receipt-search.svg";
import betslip from "../assets/images/bet-frenzy/menu-icons/ticket.svg";

import menuIcon from "../assets/images/bet-frenzy/menu-icons/menu.svg";
import game from "../assets/images/comingSoon/minigames.svg";
import casino from "../assets/images/comingSoon/casino.svg";
import livecasino from "../assets/images/comingSoon/livecasino.svg";
import sports from "../assets/images/comingSoon/sport.svg";

import selectedMenuIcon from "../assets/images/comingSoon/all2.svg";
import selectedgame from "../assets/images/comingSoon/minigames2.svg";
import selecteCasino from "../assets/images/comingSoon/casino2.svg";
import selectedLivesacino from "../assets/images/comingSoon/livecasino2.svg";
import selectedSports from "../assets/images/comingSoon/sport2.svg";
import eSports from "../assets/images/bet-frenzy/icons/game.png";

import { useSelector } from "react-redux";

import Rakeback from "../assets/images/bet-frenzy/Profile-Icons/Layer_1.svg";
import Gifts from "../assets/images/bet-frenzy/Profile-Icons/gift2.svg";
import MyBets from "../assets/images/bet-frenzy/Profile-Icons/account-verification.svg";
import Dashboard from "../assets/images/bet-frenzy/Profile-Icons/dashboard 2.svg";
import Deposit from "../assets/images/bet-frenzy/Profile-Icons/depositMoney 1.svg";
import Withdraw from "../assets/images/bet-frenzy/Profile-Icons/withdrawMoney 1.svg";
import Crypto from "../assets/images/bet-frenzy/Profile-Icons/download 2.svg";
import Freespin from "../assets/images/bet-frenzy/Profile-Icons/bonus 1.svg";
import Notifications from "../assets/images/bet-frenzy/Profile-Icons/notifications 1.svg";
import PersonalInfo from "../assets/images/bet-frenzy/Profile-Icons/download 6.svg";
import AccVerification from "../assets/images/bet-frenzy/Profile-Icons/verification 1.svg";
import TransactionHistory from "../assets/images/bet-frenzy/Profile-Icons/download 8.svg";

export function useOutsideAlerter(ref, open, setOpen) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      const logoClass = event?.target?.className;
      if (logoClass && typeof logoClass !== "object") {
        if (logoClass?.indexOf("toggleIcon") !== -1) {
          setOpen(!open);
        } else if (ref?.current && !ref.current?.contains(event?.target)) {
          setOpen(open);
        }
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

export const setCookies = (key, value) => {
  document.cookie = key + "=" + (value || "") + "; path=/";
};

export const getCookies = (key) => {
  const value = ("; " + document.cookie).split(`; ${key}=`).pop().split(";")[0];
  return value;
};

export const deleteCookies = (name) => {
  document.cookie =
    name +
    "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Strict; Secure";
};

export let sidebarDrawerInit = false;

// export const handleSidebarDrawerInit = () => {
//   sidebarDrawerInit = !sidebarDrawerInit;
//   return sidebarDrawerInit;
// };

export const handleSidebarDrawerInit = () => {
  sidebarDrawerInit = !sidebarDrawerInit;
  return sidebarDrawerInit;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "-"; // fallback if null/undefined

  return new Date(dateString).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata", // IST
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    // second: "2-digit",
  });
};

export const formatDate = (inputDate) => {
  const date = new Date(inputDate);
  const day = String(date.getDate()).padStart(2, "0"); // DD
  const month = String(date.getMonth() + 1).padStart(2, "0"); // MM
  const year = date.getFullYear(); // YYYY
  return `${day}-${month}-${year}`;
};

export const getReadableDate = (dateString) => {
  const inputDate = new Date(dateString);
  const today = new Date();

  // Normalize both dates to midnight for comparison
  const input = new Date(
    inputDate.getFullYear(),
    inputDate.getMonth(),
    inputDate.getDate()
  );
  const current = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  const diffTime = current - input; // difference in milliseconds
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  if (diffDays == 0) return "Today";
  if (diffDays == 1) return "Yesterday";

  // Return formatted date: e.g. Jun 28, 2025
  const options = { year: "numeric", month: "short", day: "numeric" };
  return inputDate.toLocaleDateString(undefined, options);
};

export const getReadableTime = (dateString) => {
  const date = new Date(dateString);

  return date.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const checkImageURL = (url) => {
  if (!url) return false;
  else {
    const pattern = new RegExp(
      "^https?:\\/\\/.+\\.(png|jpg|jpeg|bmp|gif|webp)$",
      "i"
    );
    return pattern.test(url);
  }
};
// Example usage:

export const sideBarListNew = [
  // {
  //   label: "Profile Details",
  //   url: "profile-dashboard/personal-info",
  //   name: "profileDetails",
  //   img: (
  //     <img
  //       src={Profile}
  //       alt="icon"
  //       width={22}
  //       height={22}
  //       className="svg-icon"
  //     />
  //   ),
  // },
  // {
  //   label: "Setting",
  //   url: "profile-dashboard/cms",
  //   name: "setting",
  //   img: (
  //     <img
  //       src={Payment}
  //       alt="icon"
  //       width={22}
  //       height={22}
  //       className="svg-icon"
  //     />
  //   ),
  // },
  {
    label: "Rakeback",
    url: "profile-dashboard/rakeback",
    name: "rakeback",
    img: (
      <img
        src={Rakeback}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Dashboard",
    url: "profile-dashboard/dashboard",
    name: "dashboard",
    img: (
      <img
        src={Dashboard}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Deposit",
    url: "profile-dashboard/deposit",
    name: "deposit",
    img: (
      <img
        src={Deposit}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Withdraw",
    url: "profile-dashboard/withdraw",
    name: "withdraw",
    img: (
      <img
        src={Withdraw}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Buy Crypto",
    url: "profile-dashboard/buy-crypto",
    name: "buy-crypto",
    img: (
      <img
        src={Crypto}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Gifts",
    url: "profile-dashboard/gifts",
    name: "gifts",
    img: (
      <img
        draggable="false"
        src={Gifts}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Freespin Promo",
    url: "profile-dashboard/freespin",
    name: "freespin",
    img: (
      <img
        src={Freespin}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Notifications",
    url: "profile-dashboard/notifications",
    name: "notifications",
    img: (
      <img
        src={Notifications}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Personal Information",
    url: "profile-dashboard/personal-info",
    name: "personal-info",
    img: (
      <img
        src={PersonalInfo}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Transaction History",
    url: "profile-dashboard/transaction-history",
    name: "transaction-history",
    img: (
      <img
        src={TransactionHistory}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "My Bets",
    url: "profile-dashboard/my-bets",
    name: "my-bets",
    img: (
      <img
        src={MyBets}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Account Verification",
    url: "profile-dashboard/account-verification",
    name: "account-verification",
    img: (
      <img
        src={AccVerification}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
];

export const sideBarList = [
  {
    label: "Profile Details",
    url: "profile-details",
    name: "profileDetails",
    img: (
      <img
        src={Profile}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Payment Details",
    url: "payment-details",
    name: "paymentDetails",
    img: (
      <img
        src={Payment}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Referral Earnings",
    url: "referral-earning",
    name: "referEarning",
    img: (
      <img
        loading="lazy"
        src={Refer}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "Bonus",
    url: "bonus",
    name: "bonus",
    img: (
      <img
        loading="lazy"
        src={Note}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "My Bets",
    url: "my-bets",
    name: "myBets",
    img: (
      <img
        loading="lazy"
        src={Note}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "My Wallet",
    url: "wallet",
    name: "myWallet",
    img: (
      <img
        src={Wallet}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Betting Profit & Loss",
    url: "bet-profit-loss",
    name: "betProfitLoss",
    img: (
      <img
        src={Betting}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Leaderboard",
    url: "leaderboard",
    name: "leaderboard",
    img: (
      <img
        src={Leader}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Mission",
    url: "mission",
    name: "mission",
    img: (
      <img
        src={Mission}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Loyalty",
    url: "loyalty",
    name: "loyalty",
    img: (
      <img
        src={Loyalty}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
];

export const casinoIcons = [
  {
    img: (
      <img
        loading="lazy"
        src={Live}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={Others}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    img: (
      <img
        src={Virtual}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    img: (
      <img
        loading="lazy"
        src={Crash}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={VirtualCasino}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    img: (
      <img
        loading="lazy"
        src={Slot}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        loading="lazy"
        src={Lobby}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        loading="lazy"
        src={Table}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        loading="lazy"
        src={Bet}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={Casual}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    img: (
      <img
        src={Sports}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    img: (
      <img
        loading="lazy"
        src={Fish}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },

  {
    img: (
      <img
        loading="lazy"
        src={Video}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={LivePopular}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    img: (
      <img
        loading="lazy"
        src={Mini}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={Arcade}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    img: (
      <img
        loading="lazy"
        src={Bing}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
];

export const downSideBarList = [
  {
    label: "Settings",
    url: "",
    name: "setting",
    img: (
      <img
        src={Setting}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
    type: "dropdown",
    dropdown: [],
  },

  // {
  //   label: "Logout",
  //   url: "logout",
  //   name: "logout",
  //   img: (
  //     <img
  //       src={Logout}
  //       alt="icon"
  //       width={22}
  //       height={22}
  //       className="svg-icon"
  //     />
  //   ),
  // },
];

export const bottomSideBarList = [
  {
    label: "Live chat 24/7",
    url: "chat",
    name: "liveChat",
    img: (
      <img
        src={LiveChat}
        alt="icon"
        width={30}
        height={30}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "Affiliate",
    url: "affiliate-section",
    name: "affiliate",
    img: (
      <img
        src={Affiliate}
        alt="icon"
        width={30}
        height={30}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
];

export const cmsSideBarList = [
  {
    label: "TERMS CONDITION",
    url: "cms/TERMS_CONDITION",
    name: "terms",
    img: (
      <img
        src={Logout}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "RESPONSIBLE GAMING",
    url: "cms/RESPONSIBLE_GAMING",
    name: "responsibleGame",
    img: (
      <img
        src={Logout}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "PRIVACY POLICY",
    url: "cms/PRIVACY_POLICY",
    name: "privacyPolicy",
    img: (
      <img
        src={Logout}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "SPORTSBOOK TERMS",
    url: "cms/SPORTSBOOK_TERMS",
    name: "sportsbookTerms",
    img: (
      <img
        src={Logout}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "FAQ",
    url: "cms/FAQ",
    name: "faq",
    img: (
      <img
        src={Logout}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "KYC POLICY",
    url: "cms/KYC_POLICY",
    name: "kycPolicy",
    img: (
      <img
        src={Logout}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
  {
    label: "FAIRNESS RNG METHODS",
    url: "cms/FAIRNESS_RNG_METHODS",
    name: "fairnessRng",
    img: (
      <img
        src={Logout}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
        loading="lazy"
      />
    ),
  },
];

export const sportsBarList = [
  { name: "cricket", img: cricket },
  { name: "prematch", img: upcoming },
  { name: "Live", img: live },
  { name: "Virtual", img: virrual },
  { name: "esports", img: espo },
  { name: "racing", img: racing },
];

export const liveCasinoBarList = [
  { name: "My Favorites", url: "/live-casino-games/my-favorites" },
  { name: "Live Baccarat", url: "/live-casino-games/live-baccarat" },
  { name: "Table Games", url: "/live-casino-games/table-games" },
  { name: "Live Blackjack", url: "/live-casino-games/live-blackjack" },
  { name: "Popular Casino", url: "/live-casino-games/popular-casino" },
  { name: "Live Roulette", url: "/live-casino-games/live-roulette" },
  { name: "Live Poker", url: "/live-casino-games/live-poker" },
  { name: "Casino Holdem", url: "/live-casino-games/casino-holdem" },
  { name: "Game Shows", url: "/live-casino-games/game-shows" },
  { name: "Popular Slots", url: "/live-casino-games/popular-slots" },
  { name: "Video Slots", url: "/live-casino-games/video-slots" },
  { name: "Sic Bo", url: "/live-casino-games/sic-bo" },
  { name: "Other", url: "/live-casino-games/other" },
];

export const Languages = [
  { label: "English", value: "en" },
  // { label: "অসমীয়া", value: "as" }, // Assamese
  // { label: "বাংলা", value: "bn" }, // Bengali
  // { label: "बर'", value: "brx" }, // Bodo
  // { label: "डोगरी", value: "doi" }, // Dogri
  // { label: "ગુજરાતી", value: "gu" }, // Gujarati
  // { label: "हिन्दी", value: "hi" }, // Hindi
  // { label: "ಕನ್ನಡ", value: "kn" }, // Kannada
  // { label: "کٲشُر", value: "ks" }, // Kashmiri
  // { label: "कोंकणी", value: "kok" }, // Konkani
  // { label: "मैथिली", value: "mai" }, // Maithili
  // { label: "മലയാളം", value: "ml" }, // Malayalam
  // { label: "মৈতৈলোন", value: "mni" }, // Manipuri (Meitei)
  // { label: "मराठी", value: "mr" }, // Marathi
  // { label: "नेपाली", value: "ne" }, // Nepali
  // { label: "ଓଡ଼ିଆ", value: "or" }, // Odia
  // { label: "ਪੰਜਾਬੀ", value: "pa" }, // Punjabi
  // { label: "संस्कृत", value: "sa" }, // Sanskrit
  // { label: "ᱥᱟᱱᱛᱟᱲᱤ", value: "sat" }, // Santali
  // { label: "سنڌي", value: "sd" }, // Sindhi
  // { label: "தமிழ்", value: "ta" }, // Tamil
  // { label: "తెలుగు", value: "te" }, // Telugu
  // { label: "اردو", value: "ur" }, // Urdu
];

export const SidebarStaticIcons = [
  Live,
  Others,
  Virtual,
  Crash,
  VirtualCasino,
  Slot,
  Lobby,
  Table,
  Bet,
  Casual,
  Sports,
  Fish,
  Video,
  LivePopular,
  Mini,
  Arcade,
  Bing,
];

export const LoginSignUpStaticImages = [
  BgImage,
  LoginCard,
  Login,
  SignUp,
  LoginMask,
];

export const usePreloadSelectors = () => {
  const casinoProviders = useSelector(
    (state) => state.config?.data?.casinoProviders || []
  );
  const gameItems = useSelector((state) => state.games?.gameList || []);
  const banners = useSelector((state) => state.config?.data?.banners || []);

  return useMemo(
    () => ({ casinoProviders, gameItems, banners }),
    [casinoProviders, gameItems, banners]
  );
};

// export const usePreloadSelectors = () => {
//   const casinoProviders = useSelector(
//     (state) => state.config?.data?.casinoProviders || []
//   );
//   const gameItems = useSelector((state) => state.games?.gameList || []);
//   const banners = useSelector((state) => state.config?.data?.banners || []);

//   return { casinoProviders, gameItems, banners };
// };

export const PopularGames = [
  {
    img: (
      <img
        src={CricketGame}
        alt="icon"
        className="grid-item provider-list-4 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={Basketball}
        alt="icon"
        className="grid-item provider-list-4 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={Football}
        alt="icon"
        className="grid-item provider-list-4 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={Tennis}
        alt="icon"
        width={22}
        height={22}
        className="grid-item provider-list-4 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={Baseball}
        alt="icon"
        className="grid-item provider-list-4 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={Formula}
        alt="icon"
        className="grid-item provider-list-4 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={Valorant}
        alt="icon"
        className="grid-item provider-list-4 cursor-pointer"
      />
    ),
  },
];

export const CasinoGames = [
  {
    img: (
      <img
        src={IMG1}
        alt="icon"
        className="grid-item provider-list-2 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG2}
        alt="icon"
        className="grid-item provider-list-2 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG1}
        alt="icon"
        className="grid-item provider-list-2 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG2}
        alt="icon"
        width={22}
        height={22}
        className="grid-item provider-list-2 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG1}
        alt="icon"
        className="grid-item provider-list-2 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG2}
        alt="icon"
        className="grid-item provider-list-2 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG1}
        alt="icon"
        className="grid-item provider-list-2 cursor-pointer"
      />
    ),
  },
];

export const LiveCasinoGames = [
  {
    img: (
      <img
        src={IMG3}
        alt="icon"
        className="grid-item provider-list-3 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG4}
        alt="icon"
        className="grid-item provider-list-3 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG3}
        alt="icon"
        className="grid-item provider-list-3 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG4}
        alt="icon"
        width={22}
        height={22}
        className="grid-item provider-list-3 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG3}
        alt="icon"
        className="grid-item provider-list-3 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG4}
        alt="icon"
        className="grid-item provider-list-3 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMG3}
        alt="icon"
        className="grid-item provider-list-3 cursor-pointer"
      />
    ),
  },
];
export const PromoGames = [
  {
    img: (
      <img
        src={IMPK}
        alt="icon"
        className="grid-item provider-list-3 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMPK}
        alt="icon"
        className="grid-item provider-list-3 cursor-pointer"
      />
    ),
  },
  {
    img: (
      <img
        src={IMPK}
        alt="icon"
        className="grid-item provider-list-3 cursor-pointer"
      />
    ),
  },
];

export const casinoCategoriesList = [
  {
    name: "Drops & Wins",
    url: `/casino-games/drop-wins`,
  },
  {
    name: "My Favourite",
    url: `/casino-games/my-favourite`,
  },
  {
    name: "Video Slots",
    url: `/casino-games/video-slots`,
  },
  {
    name: "Scratch Cards",
    url: `/casino-games/scratch-cards`,
  },
  {
    name: "Classic Slots",
    url: `/casino-games/classic-slots`,
  },
  {
    name: "Jackpot Games",
    url: `/casino-games/jackpot-games`,
  },
  {
    name: "Popular Slots",
    url: `/casino-games/popular-slots`,
  },
  {
    name: "Video Poker",
    url: `/casino-games/video-poker`,
  },
  {
    name: "Table Games",
    url: `/casino-games/table-games`,
  },
  {
    name: "Bonus Buy",
    url: `/casino-games/bonus-buy`,
  },
  {
    name: "Instant Games",
    url: `/casino-games/instant-games`,
  },
  {
    name: "Lotto",
    url: `/casino-games/lotto`,
  },
  {
    name: "Other",
    url: `/casino-games/other`,
  },
  {
    name: "Megaways",
    url: `/casino-games/megaways`,
  },
  {
    name: "Video Bingos",
    url: `/casino-games/video-bingos`,
  },
  {
    name: "Polular Casino",
    url: `/casino-games/popular-casino`,
  },
  {
    name: "Fish",
    url: `/casino-games/fish`,
  },
  {
    name: "New Games",
    url: `/casino-games/new-games`,
  },
];

export const navItems = [
  {
    icon: menuIcon,
    selectedIcon: selectedMenuIcon,
    label: "ALL",
    link: "#",
    textKey: "MENU__MENU",
    color: "#fff",
  },
  {
    icon: game,
    selectedIcon: selectedgame,
    label: "GAMES",
    link: "instant-game-list",
    textKey: "MENU__MINI_GAMES",
    color: "#884EFF",
  },
  {
    icon: casino,
    selectedIcon: selecteCasino,
    label: "CASINO",
    link: "/casino-games/popular-casino",
    textKey: "MENU__CASINO",
    color: "#F7904E",
  },
  {
    icon: livecasino,
    selectedIcon: selectedLivesacino,
    label: "LIVE CASINO",
    link: "/live-casino-games/my-favorites",
    textKey: "MENU__LIVE_CASINO",
    color: "#F44141",
  },
  {
    icon: sports,
    selectedIcon: selectedSports,
    label: "SPORTS",
    link: "/sportsbook/prematch",
    textKey: "MENU__SPORT",
    color: "#00EC66",
  },
];
export const navSportsItems = [
  {
    icon: menuIcon,
    selectedIcon: menuIcon,
    label: "ALL",
    link: "#",
    textKey: "MENU__MENU",
    color: "#fff",
  },
  {
    icon: playLive,
    selectedIcon: playLive,
    label: "LIVE",
    link: "/sportsbook/prematch",
    textKey: "LIVE",
    color: "#884EFF",
  },
  {
    icon: betslip,
    selectedIcon: betslip,
    label: "BETSLIP",
    link: "/sportsbook/prematch",
    textKey: "BETSLIP",
    color: "#F7904E",
  },
  {
    icon: myBets,
    selectedIcon: myBets,
    label: "MYBETS",
    link: "/sportsbook/prematch",
    textKey: "MYBETS",
    color: "#F44141",
  },
  {
    icon: drafts,
    selectedIcon: drafts,
    label: "DRAFTS",
    link: "/sportsbook/prematch",
    textKey: "DRAFTS",
    color: "#00EC66",
  },
];

export const searchCategoryOptions = [
  {
    name: "All",
    search: "all",
    icon: null,
  },
  {
    name: "Casino",
    search: "casino",
    icon: selecteCasino,
  },
  {
    name: "Live Casino",
    search: "live",
    icon: selectedLivesacino,
  },
  {
    name: "Sports",
    search: "sport",
    icon: selectedSports,
  },
  {
    name: "E Sports",
    search: "sport",
    icon: eSports,
  },
];
